import Cookies from "js-cookie";
import { useEffect } from "react";
import {
	FLEX_BRIDGE_EVENTS,
	initFlexBridge,
	onFlexAppEvent,
	sendToFlexApp,
} from "@/lib/flexBridge";
import { isFlexApp } from "./useIsFlexApp";

/**
 * Handles auth token received from the Flex native app shell.
 * When the native shell sends USER_AUTH_TOKEN, we store it as a cookie
 * (same as handleLoginSuccess does) and reload to pick up the auth state.
 */
export function useFlexAppAuth() {
	useEffect(() => {
		if (!isFlexApp()) return;

		initFlexBridge();

		const unsubscribe = onFlexAppEvent(
			FLEX_BRIDGE_EVENTS.USER_AUTH_TOKEN,
			(payload: { authToken: string }) => {
				if (payload?.authToken) {
					// Set auth token as cookie (same as loginSuccess.ts does)
					const expires = new Date();
					expires.setFullYear(expires.getFullYear() + 20);
					Cookies.set("user_auth_token", payload.authToken, {
						expires,
						path: "/",
					});

					// Reload to pick up authenticated state
					window.location.reload();
				}
			},
		);

		return () => {
			unsubscribe();
		};
	}, []);
}

/**
 * Trigger the native login sheet.
 * Call this instead of showing the web LoginModal when inside the Flex app.
 */
export function triggerFlexLogin(): void {
	sendToFlexApp(FLEX_BRIDGE_EVENTS.LOGIN_CLICKED);
}

/**
 * Notify the native app that logout was successful.
 * Call this after the web logout API completes.
 */
export function notifyFlexLogout(): void {
	sendToFlexApp(FLEX_BRIDGE_EVENTS.LOGOUT_SUCCESS);
}
